import React from "react";
import { STATUS_ORDER, STATUS_LABELS, formatDate } from "@/lib/api";
import { Check } from "lucide-react";

export default function StatusTimeline({ status, timeline = [], compact = false }) {
  const currentIdx = STATUS_ORDER.indexOf(status);

  return (
    <div data-testid="status-timeline" className="brand-card p-6">
      <div className="flex items-center justify-between mb-5 pb-4 border-b border-slate-100">
        <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500 font-semibold">Case Status</div>
        <div className="text-xs font-semibold text-emerald-brand">
          {STATUS_LABELS[status] || status}
        </div>
      </div>

      <ol className="space-y-5">
        {STATUS_ORDER.map((s, i) => {
          const reached = i <= currentIdx;
          const active = i === currentIdx;
          const event = timeline.find((t) => t.status === s);
          return (
            <li key={s} className="relative flex gap-4" data-testid={`timeline-step-${s}`}>
              {i < STATUS_ORDER.length - 1 && (
                <span
                  aria-hidden
                  className={`absolute left-[11px] top-7 bottom-[-20px] w-px ${reached && i < currentIdx ? "bg-emerald-brand" : "bg-slate-200"}`}
                />
              )}
              <div
                className={`relative z-10 mt-0.5 h-[22px] w-[22px] shrink-0 rounded-full inline-flex items-center justify-center ${
                  active ? "bg-emerald-brand text-white ring-4 ring-emerald-brand/20" :
                  reached ? "bg-emerald-brand text-white" :
                  "bg-slate-100 text-slate-400"
                }`}
              >
                {reached ? <Check className="w-3 h-3" strokeWidth={3} /> : <span className="text-[10px] font-semibold">{i + 1}</span>}
              </div>
              <div className="flex-1 pb-1">
                <div className={`text-sm font-semibold ${reached ? "text-slate-900" : "text-slate-400"}`}>
                  {STATUS_LABELS[s]}
                </div>
                {!compact && event && (
                  <div className="mt-1">
                    {event.note && <div className="text-xs text-slate-600 mt-0.5">{event.note}</div>}
                    <div className="text-[11px] text-slate-400 mt-1">
                      {event.actor ? `${event.actor} · ` : ""}{formatDate(event.at)}
                    </div>
                  </div>
                )}
              </div>
            </li>
          );
        })}
      </ol>
    </div>
  );
}
